

























































































import Vue, { PropType } from "vue";
import ListItem from "./../interface/ListItem.vue";
import { Mandaat } from "../../types/opdrachten/Mandaat";

export default Vue.extend({
  name: "mandaten-view",
  components: {
    ListItem
  },
  props: {
    mandaten: {
      type: Array as PropType<Array<Mandaat>>,
      required: true
    }
  },
  methods: {
    moneyNotation(bedrag: number): string {
          return "€ " + bedrag.toString().replace(".", ",");
    },
    suffixForMandaatBedrag(mandaat: Mandaat): string {
      if (mandaat.bedrag > 0) {
        if (mandaat.bedragGeindexeerd) {
          return "(geïndexeerd)";
        } else {
          return "(niet geïndexeerd)";
        }
      }
      return "";
    }
  }
});
